import { useState } from "react";
import { useAppContext } from "../../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../../controller/article/ArticleController";
import { UserController, UserControllerType } from "../../../../../controller/user/UserController";
import ArticleDto from "../../../../../model/manuscript/ArticleDto";
import { handleErrorMessage, parseArticleForBackend, useEffectOnce } from "../../../../../utils/Utils";

interface ReviewersServiceType {
  articleSave: any;
  reviewerList: any;
  saveSuggestedReviewer: any;
  open: any;
  setOpen: any;
  openModal: any;
  closeModal: any;
}

export default function ReviewersService(): ReviewersServiceType {
  const { showMessage } = useAppContext();
  const { axiosGetReviewerList }: UserControllerType = UserController();
  const { axiosArticleUpdate, axiosPostSuggestedReviewer }: ArticleControllerType = ArticleController();
  const [open, setOpen] = useState<boolean>(false);
  const [reviewerList, setReviewerList] = useState<any[]>([]);

  useEffectOnce(() => {
    getReviewerList();
  });

  const articleSave = (values: any, article: any, setArticle: any, handleNext: any) => {
    let newArticle = parseArticleForBackend({
      ...article,
      ...values,
      authorsIds: article.articleAuthors ? article.articleAuthors.map((a: any) => a.id) : undefined,
    });
    axiosArticleUpdate(newArticle)
      .then((response: any) => {
        setArticle((article: ArticleDto) => {
          return { ...article, ...values };
        });
        handleNext();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };
  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };
  const getReviewerList = () => {
    axiosGetReviewerList()
      .then((result: any) => {
        const parse = result.data.map((x: any) => {
          return { name: x.firstName + " " + x.lastName, code: x.id };
        });
        setReviewerList(parse);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const saveSuggestedReviewer = (articleId: any, reviewer: any, setArticle: any) => {
    axiosPostSuggestedReviewer(articleId, reviewer)
      .then((response: any) => {
        setArticle((prev: any) => {
          return { ...prev, suggestedReviewers: response.data.suggestedReviewers };
        });
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return { articleSave, reviewerList, saveSuggestedReviewer, open, setOpen, openModal, closeModal };
}

export type { ReviewersServiceType };
